import { CUSTOMER_TYPE_BUSINESS } from 'shared/constants'
import featureToggles from 'shared/featureToggles'
import { formatToGrs } from 'shared/time-utilites'

export const mapBoletoData = boletoData => {
    if (!boletoData) {
        return {}
    }

    const {
        documentNumber: CustomerDocumentNumber,
        postalCode: PostalCode,
        street: Street,
        streetNumber,
        district: District,
        city: City,
        state: State,
        complement: Complement,
    } = boletoData

    return {
        BOLETOPAYMENTINFO: {
            CustomerDocumentType: CUSTOMER_TYPE_BUSINESS,
            CustomerDocumentNumber,
            PostalCode,
            Street,
            Number: streetNumber,
            District,
            City,
            State,
            Complement,
        },
    }
}

export const generateReservationList = (
    items,
    userDetails,
    selectedVehicleDetails,
    apiLanguageCode,
    card,
    boletoData,
    currentCustomerFlowType,
    startedWithProductId,
    inboundNumber,
    outboundNumber,
    additionalServices,
    PIX,
    reservationId
) =>
    items.map(item => {
        const { rate, vehicles, promoCode, autoRenew } = item
        const {
            eDataLocationId: locationId,
            rateId,
            fromDate,
            toDate,
            actualFromDate,
            actualToDate,
            waitingListKey,
            eventId,
        } = rate
        const { id: vehicleId, tag, state } = vehicles[0] || {}

        const { firstName, lastName, phone, address, deliveryAddress: delivery, billingAddress } = userDetails

        const email = userDetails?.emailAddress || userDetails?.email

        const { id: ccId, cardLast4, name: ccName, cardType, expDate, token } = card || {}

        const threeDsParams = featureToggles.has3dsPayment
            ? {
                  BROWSERCOLORDEPTH: screen.colorDepth,
                  BROWSERJAVAENABLED: navigator.javaEnabled(),
                  BROWSERLANGUAGE: navigator.language,
                  BROWSERSCREENHEIGHT: screen.height,
                  BROWSERSCREENWIDTH: screen.width,
                  BROWSERTIMEZONE: new Date().getTimezoneOffset(),
                  ENABLE3DS: true,
              }
            : {}

        return {
            EVENTID: eventId ? eventId : undefined,
            LOC: locationId,
            RATEID: rateId,
            FD: formatToGrs(fromDate),
            TD: formatToGrs(toDate),
            ACTUALFDATE: formatToGrs(actualFromDate),
            ACTUALTODATE: formatToGrs(actualToDate),
            EM: email,
            VEHID: vehicleId,
            LP: selectedVehicleDetails.tag,
            STATE: state,
            VMDL: selectedVehicleDetails.model,
            VMKE: selectedVehicleDetails.make,
            LPS: selectedVehicleDetails.state,
            VCLR: selectedVehicleDetails.color,
            VEHLIST: vehicles.length > 1 ? vehicles.map(parseVehicleData) : null,
            WLKEY: waitingListKey,

            PRMCODE: promoCode ? promoCode.barcode : undefined,
            PRMAMT: promoCode ? promoCode.promoDiscount : undefined,
            ISAUTORNW: autoRenew || false,
            ISOLANGCODE: apiLanguageCode,
            WIDGETKEY: window.WIDGET_KEY || 'Web',

            PKRFNAME: firstName,
            PKRLNAME: lastName,
            PKREMAIL: email,
            PKRMOB: phone,
            PKRADDR1: address?.address1,
            PKRADDR2: address?.address2,
            PKRCITY: address?.city,
            PKRSTATE: address?.state,
            PKRZIP: address?.postalCode,
            PKRDISTRICT: billingAddress?.district,
            PKRNUMBER: billingAddress?.streetNumber,

            DLVRYNAME: `${firstName} ${lastName}`,
            DLVRYADDR1: delivery?.address1,
            DLVRYADDR2: delivery?.address2,
            DLVRYCITY: delivery?.city,
            DLVRYSTATE: delivery?.state,
            DLVRYZIP: delivery?.postalCode,
            DLVRDISTRICT: delivery?.district,
            DLVRNUMBER: delivery?.streetNumber,

            CCID: ccId,
            CRDLAST4: cardLast4,
            CRDNAME: ccName,
            CRDTYPE: cardType,
            SCKEY: WIDGET_TYPE,
            EXP: expDate,
            ...mapBoletoData(boletoData),
            ...(featureToggles.newAuthFlow ? { PN: token } : {}),
            CUSTOMERFLOWTYPE: currentCustomerFlowType,
            STARTEDWITHPRODUCTID: startedWithProductId,
            INBOUNDFLGTNO: inboundNumber,
            OUTBOUNDFLGTNO: outboundNumber,
            RESERVATIONOPTION: additionalServices,
            PMTMHD: PIX,
            ID: reservationId,
            ...threeDsParams,
        }
    })

export const guestCheckoutReservationData = (
    token,
    items,
    userDetails,
    selectedVehicleDetails,
    apiLanguageCode,
    inboundNumber,
    outboundNumber,
    PIX
) => ({
    Is_EComm: true,
    ReservationInfoList: [
        {
            EM: userDetails.email,
            PKREMAIL: userDetails.email,
            ACTUALFDATE: items.rate.actualFromDateISO,
            WIDGETKEY: window.WIDGET_KEY || 'Web',
            FD: items.rate.actualFromDate,
            LOC: items.rate.locationId,
            ACTUALTODATE: items.rate.actualToDateISO,
            TD: items.rate.actualToDate,
            RATEID: items.rate.rateId,
            SCKEY: WIDGET_TYPE,
            ISOLANGCODE: apiLanguageCode,
            PN: token,
            LP: selectedVehicleDetails.tag,
            VMKE: selectedVehicleDetails.make,
            VMDL: selectedVehicleDetails.model,
            LPS: selectedVehicleDetails.state,
            VCLR: selectedVehicleDetails.color,
            PKRLNAME: userDetails.lastName,
            PKRFNAME: userDetails.firstName,
            PKRMOB: userDetails.phone,
            OUTBOUNDFLGTNO: outboundNumber,
            INBOUNDFLGTNO: inboundNumber,
            PMTMHD: PIX,
            PRMCODE: items?.promoCode?.barcode || undefined,
            PRMAMT: items?.promoCode?.promoDiscount || undefined,
            CUSTDOCTYPE: userDetails.documentType,
            CUSTDOCNUM: userDetails?.documentNumber?.replace(/\D/g, ''),
        },
    ],
})

export const parseVehicleData = ({ id, state, tag, name, color, make, model }) => ({
    ID: id,
    STATE: state,
    TAG: tag,
    NAME: name,
    COLOR: color,
    MAKE: make,
    MODEL: model,
    VEHID: id,
})
